import 'core-js/web/url';
import 'core-js/web/url-search-params';

export const buildUrl = (
  baseUrl: string,
  queryParams: { [name: string]: any },
) => {
  const parsedUrl = new URL(baseUrl, 'https://theintercept.com');

  for (const name in queryParams) {
    const value = queryParams[name];

    if (typeof value !== 'undefined') {
      parsedUrl.searchParams.set(name, String(value));
    }
  }

  return parsedUrl.toString();
};
